import { ForumManagement } from '../components/ForumManagement';

export function AdminForumPage() {
  return <ForumManagement />;
}